import { CSSProperties, FC } from 'react';
import styled from 'styled-components';
import { AllieLastQueriesEmptyState, QueryItem, QueryItemDataProps } from './components';

interface AllieLastQueriesProps {
  queries: QueryItemDataProps[];
  emptyMessage: string;
  style?: CSSProperties;
  lineClamp?: number;
  onClick: (id: number) => void;
}

const AllieLastQueriesContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: var(--allie-spacing-md);
`;

export const AllieLastQueries: FC<AllieLastQueriesProps> = ({
  queries,
  emptyMessage,
  style,
  onClick,
  lineClamp,
}) => {
  if (queries.length === 0) {
    return <AllieLastQueriesEmptyState emptyMessage={emptyMessage} style={style} />;
  }
  return (
    <AllieLastQueriesContainer style={style}>
      {queries.map((query, index) => (
        <QueryItem key={index} {...query} onClick={() => onClick(query.id)} lineClamp={lineClamp} />
      ))}
    </AllieLastQueriesContainer>
  );
};
